import React from 'react';
import PropTypes from 'prop-types';
import ReactTooltip from 'react-tooltip';
import Button from '../../../orders/css';
import { getPdfUrl } from '../../../utils/utils';
import useOrderPdf from '../../../hooks/useOrderPdf';
import { ORDER_PDF_STATUS } from '../../../utils/orderPdf';
import { useLocalizedStringsContext } from '../../../context/LocalizedStringsContext';
import { useLocaleContext } from '../../../context/LocaleContext';

/**
 * Download link for the (worker-only) proposal PDF. Routes the click through the shared async
 * order-PDF client instead of a raw <a href> to the protected backend route — a top-level anchor
 * navigation cannot attach the Bearer token, so it would 401 under the migrated auth. HIT opens
 * immediately; MISS shows "Preparing PDF..." and auto-opens when ready.
 */
const PdfDownloadLink = ({ id, label }) => {
  const locale = useLocaleContext();
  const pdf = useOrderPdf();
  const preparing = pdf.status === ORDER_PDF_STATUS.PREPARING;
  const failed =
    pdf.status === ORDER_PDF_STATUS.FAILED || pdf.status === ORDER_PDF_STATUS.NOT_READY;
  return (
    <a
      className="download-link"
      href={getPdfUrl(id, locale)}
      onClick={e => {
        e.preventDefault();
        if (!preparing) pdf.openPdf({ orderId: id, route: getPdfUrl(id, locale) });
      }}
      title={failed ? 'PDF could not be generated. Please try again.' : undefined}
    >
      {preparing ? 'Preparing PDF...' : label}
    </a>
  );
};

PdfDownloadLink.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  label: PropTypes.node.isRequired
};

/**
 * Returns a download link for PDF. Safe to call from render (the returned component owns the hooks).
 */
export const getLink = (id, label) => <PdfDownloadLink id={id} label={label} />;

export const Tooltip = ({ children }) => {
  const localizedStrings = useLocalizedStringsContext();
  const { tooltipMessage } = localizedStrings.srtDashboard;
  return (
    <>
      {children}
      <div
        data-type="info"
        data-tip="React-tooltip"
        style={{ display: 'inline', marginLeft: '8px' }}
      >
        <i className="fa fa-question-circle"></i>
      </div>
      <ReactTooltip type="info" effect="float">
        {tooltipMessage}
      </ReactTooltip>
    </>
  );
};

Tooltip.propTypes = {
  children: PropTypes.node.isRequired
};

export const getButton = (onClick, label, isDisabled) => (
  <Button onClick={onClick} disabled={isDisabled}>
    {label}
  </Button>
);
